import React from "react"

// Rendered by `rootRoute.notFoundComponent` when neither the root route nor any
// migrated leaf matches the URL. The React app doesn't know this URL, so hand
// it back to Rails with a full-page load (the fallback the legacy
// `Router.getAndCheckUrl` used to perform).
const NotFoundRedirect = () => {
  React.useEffect(() => {
    window.location.href = window.location.pathname + window.location.search
  }, [])

  return null
}

export default NotFoundRedirect
